export const checkLimitError = (message) => {
  const match = message.match(/^DAILY_(LIKE|SUPERLIKE|REWIND|VIDEOLIKES|VIDEOPARTNERS)_LIMIT_REACHED$/);

  if (!match) return null;

  const result = match[1].toLowerCase();

  switch (result) {
    case 'videolikes':
      return 'like';

    case 'videopartners':
      return 'partners';
  }

  return match[1].toLowerCase();
};
